import makeStyles from "@mui/styles/makeStyles";
import React, { memo } from "react";
import { isMobile } from "react-device-detect";
import { animated as a, useSpring } from "react-spring";
import { dispatchAction, MenuActions } from "../../TypesAndConstants/types";
import ResolutionSelect from "./Cards/ResolutionSelect";
interface Props {
  activeMenu: MenuActions;
  closeCard: () => void;
  dispatch: (action: dispatchAction) => void;
}

const useStyles = makeStyles((theme) => ({
  container: {
    margin: "auto",
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  baseCardStyles: {
    position: "absolute",
  },
}));

export function ToolbarContainer(props: Props) {
  const { activeMenu } = props;
  const styles = useStyles();

  const newAnimation = useSpring({
    opacity: activeMenu === "new" ? 1 : 0,
    pointerEvents: activeMenu === "new" ? "auto" : "none",
    marginTop: activeMenu === "new" ? 0 : -1000,
  });

  return (
    <div
      className={styles.container}
      style={{
        display: isMobile && activeMenu !== "new" ? "none" : "flex",
        zIndex:
          activeMenu === "color" ||
          activeMenu === "brush" ||
          activeMenu === "new"
            ? 2000
            : 0,
      }}
    >
      <a.div className={styles.baseCardStyles} style={newAnimation}>
        <ResolutionSelect />
      </a.div>
    </div>
  );
}

export default memo(ToolbarContainer);
